module.exports = __webpack_public_path__ + "static/img/dataNull.51a283b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dataNull.svg
// module id = sXCJ
// module chunks = 1